export const PAYMENT_METHODS = {
    default: [
        { name: 'ideal', logo: 'ideal_2024_10_23.svg' },
        { name: 'visa', logo: 'visa.svg' },
        { name: 'mastercard', logo: 'mastercard.svg' },
        { name: 'sepa', logo: 'sepa_2024_10_23.svg' },
        { name: 'paypal', logo: 'paypal_2024_10_23.svg' },
        { name: 'cartebancaire', logo: 'cartes_bancaires_2024_10_23.svg' },
        { name: 'eps', logo: 'eps.svg' },
    ],
    nl: [
        { name: 'ideal', logo: 'ideal_2024_10_23.svg' },
        { name: 'visa', logo: 'visa.svg' },
        { name: 'mastercard', logo: 'mastercard.svg' },
        { name: 'sepa', logo: 'sepa_2024_10_23.svg' },
        { name: 'paypal', logo: 'paypal_2024_10_23.svg' },
    ],
    de: [
        { name: 'visa', logo: 'visa.svg' },
        { name: 'mastercard', logo: 'mastercard.svg' },
        { name: 'paypal', logo: 'paypal_2024_10_23.svg' },
        { name: 'sepa', logo: 'sepa_2024_10_23.svg' },
    ],
    fr: [
        { name: 'cartebancaire', logo: 'cartes_bancaires_2024_10_23.svg' },
        { name: 'visa', logo: 'visa.svg' },
        { name: 'mastercard', logo: 'mastercard.svg' },
        { name: 'paypal', logo: 'paypal_2024_10_23.svg' },
        { name: 'sepa', logo: 'sepa_2024_10_23.svg' },
    ],
    at: [
        { name: 'eps', logo: 'eps.svg' },
        { name: 'visa', logo: 'visa.svg' },
        { name: 'mastercard', logo: 'mastercard.svg' },
        { name: 'paypal', logo: 'paypal_2024_10_23.svg' },
        { name: 'sepa', logo: 'sepa_2024_10_23.svg' },
    ],
}
